import {
  ChangeDetectionStrategy,
  Component,
  output,
  inject,
} from '@angular/core';
import {
  FormBuilder,
  FormControl,
  FormGroup,
  ReactiveFormsModule,
  Validators,
} from '@angular/forms';

import {
  EmailValidator,
  FormControlComponent,
  PrimengButtonDirective,
  PrimengInputTextDirective,
} from '@web/shared/ui';
import { InputTextModule } from 'primeng/inputtext';
import { ButtonModule } from 'primeng/button';
import { RemindPasswordForm } from '../../models/remind-password-form';

type RemindPasswordFormGroup = FormGroup<{
  email: FormControl<string>;
}>;

@Component({
  selector: 'app-remind-password-form',
  imports: [
    ReactiveFormsModule,
    FormControlComponent,
    InputTextModule,
    ButtonModule,
    PrimengButtonDirective,
    PrimengInputTextDirective,
  ],
  templateUrl: './remind-password-form.component.html',
  styleUrl: './remind-password-form.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class RemindPasswordFormComponent {
  private readonly builder = inject(FormBuilder);

  public readonly submitClickEvent = output<RemindPasswordForm>();

  protected readonly form = this.buildForm();

  public handleSubmitClick(): void {
    this.submitClickEvent.emit(this.toData());
  }

  private toData(): RemindPasswordForm {
    const data = this.form.getRawValue();

    return new RemindPasswordForm(data.email);
  }

  private buildForm(): RemindPasswordFormGroup {
    return this.builder.group({
      email: this.builder.nonNullable.control('', [
        Validators.required,
        EmailValidator.email,
      ]),
    });
  }
}
